import React from 'react';
import {Route, Routes} from "react-router-dom";
import Limit1 from "./Limit1";
import Limit2 from "./Limit2";
import LimitInsert from "./LimitInsert";
import Limit3 from "./Limit3";

function Index(props) {
    return (
        <Routes>
            <Route path="/" element={<LimitInsert />}/>
            <Route path="/table1" element={<Limit1 />}/>
            <Route path="/table2" element={<Limit2 />}/>
            <Route path="/table3" element={<Limit3 />}/>
            <Route path="/table2" element={<Limit2 />}/>
        </Routes>
    );
}

export default Index;